import React from 'react'
import { twMerge } from 'tailwind-merge'

interface BlockCategoryProps {
  label: string
  onClick?: () => void
  icon?: React.ReactNode
}

export const BlockCategory = ({ label, onClick, icon }: BlockCategoryProps) => {
  return (
    <button
      type="button"
      className={twMerge(
        'flex w-full cursor-pointer items-center justify-start gap-2.5 hover:bg-btnSecondaryHover',
        'rounded-md px-3 py-4.5 text-subheading-2 text-textPrimary transition-[all_0.3s_cubic-bezier(0,0,0.8,1)]',
      )}
      onClick={onClick}
    >
      <span className="w-5 text-lg">{icon}</span>
      <div className="text-M">{label}</div>
    </button>
  )
}
